import { useParams } from "react-router-dom";
import { useIntl } from "../../lib/i18n";

export default function SectionEditorPage() {
  const { sectionTypeId = "" } = useParams();
  const { t } = useIntl();
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">
        {t("sections.title")} — {sectionTypeId}
      </h1>
      <p className="mt-4 text-slate-500">{t("sections.empty")}</p>
    </div>
  );
}
